import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

@Component({
    selector: 'auftrag-checkliste-komponente',
    template: `
        <div *ngIf="auftragdetails.checklisten && auftragdetails.checklisten.length">
          <div *ngFor="let checkliste of auftragdetails.checklisten">
            <div class="section ion-activatable">
              <app-auftrag-checkliste [auftrag]="auftrag" [auftragdetails]="auftragdetails" [checkliste]="checkliste" [titelAnzeigen]="titelAnzeigen"></app-auftrag-checkliste>
            </div>

            <div class="divider-space"></div>
          </div>
        </div>
    `,
    styles: [`
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragChecklisteComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    titelAnzeigen = true;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();

        this.titelAnzeigen = this.getEinstellung('TitelAnzeigen') !== 'nein';

        this.cdr.detectChanges();
    }
}
